import * as React from 'react';

const SvgStarFull = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2L15.2328 8.55041L22.4616 9.60081L17.2308 14.6996L18.4657 21.8992L12 18.5L5.53437 21.8992L6.7692 14.6996L1.53839 9.60081L8.76719 8.55041L12 2Z", fill: "currentColor" }));

export { SvgStarFull as default };
